import {
  buildFetchPositions,
  fetchPositionsUsecase as _fetchPositionsUsecase,
} from "./fetch-positions";
import {
  buildUpdatePosition,
  updatePositionUsecase as _updatePositionUsecase,
} from "./update-position";
import {
  buildFetchPosition,
  fetchPositionUsecase as _fetchPositionUsecase,
} from "./fetch-position";
import PositionRepository from "../../ports/positionRepository";
import { 
  buildAddPosition,
  addPositionUseCase as _addPositionUseCase,
} from "./add-position";

// eslint-disable-next-line import/no-anonymous-default-export
export default (dependencies: {
  positionRepo: PositionRepository;
}): {
  fetchPositions: _fetchPositionsUsecase;
  addPosition: _addPositionUseCase;
  updatePosition: _updatePositionUsecase;
  fetchPosition: _fetchPositionUsecase;
} => {
  const { positionRepo } = dependencies;

  const fetchPositions = buildFetchPositions({ positionRepo });
  const addPosition = buildAddPosition({ positionRepo })
  const updatePosition = buildUpdatePosition({ positionRepo });
  const fetchPosition = buildFetchPosition({ positionRepo });

  return { fetchPositions, updatePosition, fetchPosition, addPosition };
};

export type fetchPositionsUsecase = _fetchPositionsUsecase;
export type updatePositionUsecase = _updatePositionUsecase;
export type fetchPositionUsecase = _fetchPositionUsecase;
